import { map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../shared/services/global.service';
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class PipelineService {
	getData() {
		let data = {
			session_id: this._gS.session_token
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'pipeline/view_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProjects() {
		let data = {
			session_id: this._gS.session_token
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'pipeline/get_projects', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	createProject(ev) {
		let data = {
			session_id: this._gS.session_token,
			values: ev
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'pipeline/create_project', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	duplicateProject(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'pipeline/duplicate_project', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteProject(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
			id: project_id
		};
		return this.http.post(this._gS.service_url + 'pipeline/delete_project', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}


	constructor(private _cS: CookieService, private http: HttpClient, public _gS: GlobalService) {

	}
}
